import { gql } from '@apollo/client/core'

export const roomFragment = gql`
  fragment RoomProps on Room {
    id
    name
    roomType
    parentRoomType
    aliases
    mockupsCount
  }
`
